/**
 * Route for `top-publishers-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { TopPublishersWidgetPage } from "../features/top-publishers-widget/TopPublishersWidgetPage";

export const topPublishersWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/top-publishers-widget",
	component: TopPublishersWidgetPage,
});

export default topPublishersWidgetRoute;
